export var ImageFileType;
(function (ImageFileType) {
    ImageFileType["PNG"] = "image/png";
    ImageFileType["JPEG"] = "image/jpeg";
    ImageFileType["JPG"] = "image/jpg";
    ImageFileType["GIF"] = "image/gif";
    ImageFileType["BMP"] = "image/bmp";
    ImageFileType["WEBP"] = "image/webp";
    ImageFileType["SVG"] = "image/svg+xml";
    ImageFileType["HEIF"] = "image/heif";
})(ImageFileType || (ImageFileType = {}));
export var InputSupportedFileType;
(function (InputSupportedFileType) {
    InputSupportedFileType["PNG"] = "image/png";
    InputSupportedFileType["JPEG"] = "image/jpeg";
    InputSupportedFileType["JPG"] = "image/jpg";
    InputSupportedFileType["GIF"] = "image/gif";
    InputSupportedFileType["BMP"] = "image/bmp";
    InputSupportedFileType["WEBP"] = "image/webp";
    InputSupportedFileType["SVG"] = "image/svg+xml";
    InputSupportedFileType["HEIF"] = "image/heif";
    InputSupportedFileType["HEIC"] = "image/heic";
})(InputSupportedFileType || (InputSupportedFileType = {}));
export var BrowserSupportedFiles;
(function (BrowserSupportedFiles) {
    // Image types
    BrowserSupportedFiles["PNG"] = "image/png";
    BrowserSupportedFiles["JPEG"] = "image/jpeg";
    BrowserSupportedFiles["JPG"] = "image/jpg";
    BrowserSupportedFiles["GIF"] = "image/gif";
    BrowserSupportedFiles["BMP"] = "image/bmp";
    BrowserSupportedFiles["WEBP"] = "image/webp";
    BrowserSupportedFiles["SVG"] = "image/svg+xml";
    BrowserSupportedFiles["HEIC"] = "image/heic";
    BrowserSupportedFiles["HEIF"] = "image/heif";
    // Video types
    BrowserSupportedFiles["MP4"] = "video/mp4";
    BrowserSupportedFiles["WEBM"] = "video/webm";
    // Audio types
    BrowserSupportedFiles["MP3"] = "audio/mpeg";
    BrowserSupportedFiles["OGG"] = "audio/ogg";
    BrowserSupportedFiles["WAV"] = "audio/wav";
    // Document types
    BrowserSupportedFiles["PDF"] = "application/pdf";
    BrowserSupportedFiles["HTML"] = "text/html";
    BrowserSupportedFiles["JSON"] = "application/json";
    BrowserSupportedFiles["TXT"] = "text/plain";
})(BrowserSupportedFiles || (BrowserSupportedFiles = {}));
export var EmbeddableFileTypes;
(function (EmbeddableFileTypes) {
    EmbeddableFileTypes["PDF"] = "application/pdf";
    EmbeddableFileTypes["MP4"] = "video/mp4";
    EmbeddableFileTypes["WEBM"] = "video/webm";
    EmbeddableFileTypes["MP3"] = "audio/mpeg";
    EmbeddableFileTypes["OGG_AUDIO"] = "audio/ogg";
    EmbeddableFileTypes["SVG"] = "image/svg+xml";
    EmbeddableFileTypes["PNG"] = "image/png";
    EmbeddableFileTypes["JPEG"] = "image/jpeg";
    EmbeddableFileTypes["HTML"] = "text/html";
})(EmbeddableFileTypes || (EmbeddableFileTypes = {}));
//# sourceMappingURL=file.js.map